import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useSearchParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { API_BASE_URL, bankNames } from '../../config';

import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import axios from 'axios';
import { getOrganizations } from '@/views/Organizations/Organizations.api';
// core components
import GridItem from '@/components/Grid/GridItem';
import GridContainer from '@/components/Grid/GridContainer';
import CustomInput from '@/components/CustomInput/CustomInput';
import Button from '@/components/CustomButtons/Button';
import Card from '@/components/Card/Card';
import CardHeader from '@/components/Card/CardHeader';
import CardBody from '@/components/Card/CardBody';
import FormControl from '@mui/material/FormControl';
import loader from '../../assets/img/loader.svg';
import CountryDropdown from '@/components/CountryDropdown';

import {
  FormControlLabel,
  FormGroup,
  FormLabel,
  Checkbox,
} from '@mui/material';

export default function UpdateFacility() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const organizationId = searchParams.get('organizationId');
  const { id } = useParams();
  const autocompleteRef = useRef(null);

  // Add refs for form fields that need focus
  const nameRef = useRef(null);
  const emailRef = useRef(null);
  const cityRef = useRef(null);
  const stateRef = useRef(null);
  const zipcodeRef = useRef(null);
  const addressRef = useRef(null);
  const phoneRef = useRef(null);

  // State hooks
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [address, setAddress] = useState('');
  const [phone, setPhone] = useState('');
  const [redirect, setRedirect] = useState(false);
  const [image_upload, setImageUpload] = useState('');
  const [file, setFile] = useState(null);
  const [city, setCity] = useState('');
  const [state, setState] = useState('');
  const [zipcode, setZipcode] = useState('');
  const [country, setCountry] = useState('');
  const [status, setStatus] = useState('');
  const [fileimg, setFileimg] = useState('');
  const [achId, setAchId] = useState('');
  const [achCompanyName, setAchCompanyName] = useState('');
  const [bankName, setBankName] = useState('');
  const [allowAddressUpdate, setAllowAddressUpdate] = useState(false);
  const [achMethod, setAchMethod] = useState('moov');
  const [tangoGroups, setTangoGroups] = useState([]);
  const [tangoAccounts, setTangoAccounts] = useState([]);
  const [tango_group_id, setTangoGroupId] = useState('');
  const [tango_account_id, setTangoAccountId] = useState('');
  const [moovAccounts, setMoovAccounts] = useState([]);
  const [moovPaymentMethods, setMoovPaymentMethods] = useState([]);
  const [moov_account_id, setMoovAccountId] = useState('');
  const [moov_payment_method_id, setMoovPaymentMethodId] = useState('');
  const [smartPayablesAccounts, setSmartPayablesAccounts] = useState([]);
  const [smartpayables_id, setSmartPayablesId] = useState('');
  const [allowed_refund_types, setAllowedRefundTypes] = useState([]);
  const [allowedRefundAttachments, setAllowedRefundAttachments] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [organization_id, setOrganizationId] = useState(organizationId);
  const [organizations, setOrganizations] = useState([]);
  const [outbound_pgp_public_key, setOutboundPgpPublicKey] = useState('');
  const [client_facility_id, setClientFacilityId] = useState('');

  const remove = () => {
    setFileimg(false);
  };

  const handleAchId = (event) => {
    setAchId(event.target.value);
  };

  const handleAchCompanyName = (event) => {
    setAchCompanyName(event.target.value);
  };

  const handleStatus = (event) => {
    setStatus(event.target.value);
  };

  const handleCity = (event) => {
    setCity(event.target.value);
  };

  const handleState = (event) => {
    setState(event.target.value);
  };

  const handleZipcode = (event) => {
    setZipcode(event.target.value);
  };

  const handleUploadFile = (event) => {
    event.preventDefault();

    if (file === event.target.files[0]) {
      setFile(file);
      setFileimg(URL.createObjectURL(file));
    } else {
      setFile(event.target.files[0]);
      setFileimg(URL.createObjectURL(event.target.files[0]));
    }
  };

  const cancelfrm = () => {
    setRedirect(true);
  };

  /*** functions to set input values in state***/
  const handleName = (event) => {
    setName(event.target.value);
  };

  const handleEmail = (event) => {
    setEmail(event.target.value);
  };

  const handleAddress = (event) => {
    setAddress(event.target.value);
  };

  const handlePhone = (event) => {
    setPhone(event.target.value);
  };

  const handleBankName = (event) => {
    setBankName(event.target.value);
  };

  const handleAchMethod = (event) => {
    setAchMethod(event.target.value);
  };

  const handleAddressUpdate = (event) => {
    setAllowAddressUpdate(event.target.value);
  };

  const handleAllowRefundAttachments = (event) => {
    const { checked, name } = event.target;
    setAllowedRefundAttachments((prevTypes) => {
      if (checked) {
        return [...prevTypes, name];
      } else {
        return prevTypes.filter((type) => type !== name);
      }
    });
  };

  const handleAllowedRefundTypesChange = (event) => {
    const { checked, name } = event.target;
    setAllowedRefundTypes((prevTypes) => {
      if (checked) {
        return [...prevTypes, name];
      } else {
        return prevTypes.filter((type) => type !== name);
      }
    });
    if (!checked) {
      setAllowedRefundAttachments((prevTypes) =>
        prevTypes.filter((type) => type !== name),
      );
    }
  };

  const handleOutboundPgpPublicKey = (event) => {
    setOutboundPgpPublicKey(event.target.value);
  };

  const handleClientFacilityId = (event) => {
    setClientFacilityId(event.target.value);
  };

  const handlePlaceSelect = () => {
    let addressObject = autocompleteRef.current.getPlace();
    let address = addressObject.address_components;
    let zip_code;
    let city_data;
    let state_data;
    let streetNo;
    let route;

    setCity('');
    setState('');
    setZipcode('');

    for (let i = 0; i < address.length; i++) {
      if (address[i] && address[i].types[0] === 'postal_code') {
        zip_code = address[i].long_name;
        setZipcode(zip_code);
      }
      if (address[i] && address[i].types[0] === 'street_number') {
        streetNo = address[i].long_name;
      }
      if (address[i] && address[i].types[0] === 'route') {
        route = address[i].long_name;
      }
      if (
        (address[i] && address[i].types[0] === 'locality') ||
        (address[i] && address[i].types[0] === 'sublocality_level_1')
      ) {
        city_data = address[i].long_name;
        setCity(city_data);
      }
      if (address[i] && address[i].types[0] === 'administrative_area_level_1') {
        state_data = address[i].long_name;
        setState(state_data);
      }
    }

    let requiredAddress;
    if (route && streetNo) {
      requiredAddress = streetNo + ' ' + route;
    } else if (route) {
      requiredAddress = route;
    } else if (streetNo) {
      requiredAddress = streetNo;
    }

    setAddress(requiredAddress);
  };

  // Use effect hook instead of componentDidMount
  useEffect(() => {
    setLoaded(true);

    const google = window.google;

    if (google) {
      autocompleteRef.current = new google.maps.places.Autocomplete(
        document.getElementById('autocomplete'),
        {},
      );
      autocompleteRef.current.addListener('place_changed', handlePlaceSelect);
    }

    getOrganizations().then((res) => {
      setOrganizations(res.data.organizations);
    });

    axios
      .get(API_BASE_URL + '/facilities/' + id)
      .then((facility) => {
        const facilitydata = facility && facility.data;

        axios
          .get(
            API_BASE_URL + '/listTangoAccounts/' + facilitydata.tango_group_id,
          )
          .then((res) => {
            setTangoAccounts(res.data.accounts);
          });

        axios
          .get(
            API_BASE_URL +
              '/getMoovPaymentMethods/' +
              facilitydata.moov_account_id,
          )
          .then((res) => {
            setMoovPaymentMethods(res.data);
          });

        setName(facilitydata.name);
        setEmail(facilitydata.email);
        setAddress(facilitydata.address);
        setPhone(facilitydata.phone);
        setImageUpload(facilitydata.image_upload);
        setCity(facilitydata.city);
        setState(facilitydata.state);
        setZipcode(facilitydata.zipcode);
        setCountry(facilitydata.country || '');
        setStatus(facilitydata.status);
        setAchId(facilitydata.ach_id);
        setAchCompanyName(facilitydata.ach_company_name);
        setTangoGroupId(facilitydata.tango_group_id);
        setTangoAccountId(facilitydata.tango_account_id);
        setMoovAccountId(facilitydata.moov_account_id);
        setMoovPaymentMethodId(facilitydata.moov_payment_method_id);
        setSmartPayablesId(facilitydata.smartpayables_id);
        setOrganizationId(facilitydata.organization_id);
        setLoaded(false);
        setBankName(facilitydata.bank_name);
        setAllowAddressUpdate(facilitydata.allow_address_update);
        setAchMethod(facilitydata.ach_method);
        setAllowedRefundAttachments(facilitydata.allowed_refund_attachments);
        setAllowedRefundTypes(facilitydata.allowed_refund_types);
        setOutboundPgpPublicKey(facilitydata.outbound_pgp_public_key);
        setClientFacilityId(facilitydata.client_facility_id || '');
      })
      .catch((err) => {
        console.log(err);
      });

    axios.get(API_BASE_URL + '/listTangoGroups').then((res) => {
      setTangoGroups(res.data.groups);
    });

    axios.get(API_BASE_URL + '/getMoovAccounts').then((res) => {
      setMoovAccounts(res.data);
    });

    axios.get(API_BASE_URL + '/smartpayables').then((res) => {
      setSmartPayablesAccounts(res.data || []);
      if (smartpayables_id && organization_id) {
        const selectedAccount = (res.data || []).find(
          (account) => account.id === smartpayables_id,
        );
        if (
          selectedAccount &&
          selectedAccount.organization_id !== organization_id
        ) {
          setSmartPayablesId('');
        }
      }
    });

    // Cleanup function
    return () => {
      if (autocompleteRef.current) {
        google.maps.event.clearInstanceListeners(autocompleteRef.current);
      }
    };
  }, [id]);
  useEffect(() => {
    if (
      smartpayables_id &&
      organization_id &&
      smartPayablesAccounts.length > 0
    ) {
      const selectedAccount = smartPayablesAccounts.find(
        (account) => account.id === smartpayables_id,
      );
      if (
        selectedAccount &&
        selectedAccount.organization_id !== organization_id
      ) {
        setSmartPayablesId('');
      }
    }
  }, [organization_id, smartPayablesAccounts, smartpayables_id]);

  /*** function to integrate api to update facility*/
  const updatefacility = (e) => {
    e.preventDefault();

    if (name === '') {
      alert('Please enter Facility name');
      nameRef.current.focus();
      return false;
    } else if (email === '') {
      alert('Please enter Facility email');
      emailRef.current.focus();
      return false;
    } else if (city === '') {
      alert('Please enter city');
      cityRef.current.focus();
    } else if (state === '') {
      alert('Please enter state');
      stateRef.current.focus();
    } else if (zipcode === '') {
      alert('Please enter zipcode');
      zipcodeRef.current.focus();
    } else if (address === '') {
      alert('Please enter Facility address');
      addressRef.current.focus();
      return false;
    } else if (phone === '') {
      alert('Please enter Facility phone');
      phoneRef.current.focus();
    } else if (!Number(phone)) {
      alert('Phone should be in numbers only');
      phoneRef.current.focus();
      return false;
      // TODO: Remove duplicate condition check
      // eslint-disable-next-line no-dupe-else-if
    } else if (!Number(phone)) {
      alert('Phone should be in numbers only');
      phoneRef.current.focus();
      return false;
    } else if (phone.length > 12) {
      alert('Phone number length should not be greater than 12');
      phoneRef.current.focus();
      return false;
    } else if (!allowed_refund_types.length) {
      alert(
        'You need to select at least on type of refund types (Consumer Payments/Insurance)',
      );
      return false;
    } else {
      setLoaded(true);

      const formData = new FormData();
      formData.append('file', file);
      formData.append('name', name);
      formData.append('email', email);
      formData.append('address', address);
      formData.append('phone', phone);
      formData.append('city', city);
      formData.append('state', state);
      formData.append('zipcode', zipcode);
      formData.append('country', country);
      formData.append('status', status);
      formData.append('achCompanyName', achCompanyName);
      formData.append('achId', achId);
      formData.append('tango_group_id', tango_group_id);
      formData.append('tango_account_id', tango_account_id);
      formData.append('moov_account_id', moov_account_id);
      formData.append('moov_payment_method_id', moov_payment_method_id);
      formData.append('smartpayables_id', smartpayables_id);
      formData.append('organization_id', organization_id);
      formData.append('bank_name', bankName);
      formData.append('allow_address_update', allowAddressUpdate);
      formData.append('ach_method', achMethod);
      formData.append(
        'allowed_refund_attachments',
        JSON.stringify(allowedRefundAttachments),
      );
      formData.append(
        'allowed_refund_types',
        JSON.stringify(allowed_refund_types),
      );
      formData.append('outbound_pgp_public_key', outbound_pgp_public_key);
      formData.append('client_facility_id', client_facility_id);

      const headers = {
        'Content-Type': 'multipart/form-data',
      };

      axios
        .put(API_BASE_URL + '/editfacility/' + id, formData, {
          headers: headers,
        })
        .then((response) => {
          return response;
        })
        .then(() => {
          setRedirect(true);
          setLoaded(false);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  };

  const onTangoGroupChange = (e) => {
    setTangoGroupId(e.target.value);
    axios
      .get(API_BASE_URL + '/listTangoAccounts/' + e.target.value)
      .then((res) => {
        setTangoAccounts(res.data.accounts);
      });
  };

  const onMoonAccountChange = (e) => {
    setMoovAccountId(e.target.value);

    axios
      .get(API_BASE_URL + '/getMoovPaymentMethods/' + e.target.value)
      .then((res) => {
        setMoovPaymentMethods(res.data);
      });
  };

  const onMoovPaymentMethodChange = (e) => {
    setMoovPaymentMethodId(e.target.value);
  };

  const onTangoAccountChange = (e) => {
    setTangoAccountId(e.target.value);
  };

  const onOrganizationIdChange = (e) => {
    const newOrganizationId = e.target.value;
    setOrganizationId(newOrganizationId);

    if (smartpayables_id && smartPayablesAccounts.length > 0) {
      const selectedAccount = smartPayablesAccounts.find(
        (account) => account.id === smartpayables_id,
      );
      if (
        selectedAccount &&
        selectedAccount.organization_id !== newOrganizationId
      ) {
        setSmartPayablesId('');
      }
    }
  };

  const onSmartPayablesAccountChange = (e) => {
    setSmartPayablesId(e.target.value);
  };

  // Use Navigate instead of Redirect
  if (redirect) {
    const url = organizationId
      ? `/admin/updateOrganization/${organizationId}#facilities`
      : '/admin/facilities';
    navigate(url);
  }

  let logo_url;
  if (image_upload) {
    logo_url = API_BASE_URL + '/getFile?filePath=' + image_upload;
  }

  return (
    <div>
      <form onSubmit={updatefacility}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={12}>
            <Card>
              <CardHeader color='primary'>
                <h4>{t('facilities.update.title')}</h4>
              </CardHeader>
              <CardBody>
                {loaded && (
                  <div className='loaders'>
                    <img src={loader} />
                  </div>
                )}
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      type='text'
                      labelText={t('facilities.update.nameLabel')}
                      onChange={handleName}
                      value={name}
                      id='name'
                      name='name'
                      inputRef={nameRef}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.emailLabel')}
                      id='email'
                      name='email'
                      inputRef={emailRef}
                      onChange={handleEmail}
                      value={email}
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                </GridContainer>
                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.phoneLabel')}
                      id='phone'
                      name='phone'
                      inputRef={phoneRef}
                      onChange={handlePhone}
                      value={phone}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.addressLabel')}
                      id='autocomplete'
                      name='address'
                      // TODO: Replace string ref with useRef
                      // eslint-disable-next-line react/no-string-refs
                      ref='input'
                      inputRef={addressRef}
                      onChange={handleAddress}
                      value={address}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.cityLabel')}
                      id='city'
                      name='city'
                      inputRef={cityRef}
                      onChange={handleCity}
                      value={city}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.stateLabel')}
                      id='state'
                      name='state'
                      inputRef={stateRef}
                      onChange={handleState}
                      value={state}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.zipcodeLabel')}
                      id='zipcode'
                      name='zipcode'
                      inputRef={zipcodeRef}
                      onChange={handleZipcode}
                      value={zipcode}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CountryDropdown
                      value={country}
                      onChange={(e) => setCountry(e.target.value)}
                      name='country'
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.achCompanyLabel')}
                      id='achCompanyName'
                      name='achCompanyName'
                      onChange={handleAchCompanyName}
                      value={achCompanyName}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.achIdLabel')}
                      id='achId'
                      name='achId'
                      onChange={handleAchId}
                      value={achId}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-label'>
                          Status
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-label'
                          id='demo-simple-select'
                          value={status}
                          onChange={handleStatus}
                          className='full-width-elem'>
                          <MenuItem value={0}>Inactive</MenuItem>
                          <MenuItem value={1}>Active</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango'>
                          Tango Group
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango'
                          value={tango_group_id}
                          onChange={onTangoGroupChange}
                          name='group_id'
                          className='full-width-elem'>
                          {tangoGroups.map((obj) => (
                            <MenuItem key={obj && obj.id} value={obj && obj.id}>
                              {obj && obj.group_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-tango-acc'>
                          Tango Account
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-tango-acc'
                          value={tango_account_id}
                          onChange={onTangoAccountChange}
                          name='group_id'
                          className='full-width-elem'>
                          {tangoAccounts.map((obj) => (
                            <MenuItem key={obj && obj.id} value={obj && obj.id}>
                              {obj && obj.account_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='allow-address-update'>
                          Allow Address Update
                        </InputLabel>
                        <Select
                          labelId='allow-address-update'
                          value={allowAddressUpdate}
                          onChange={handleAddressUpdate}
                          name='allowAddressUpdate'
                          className='full-width-elem'>
                          <MenuItem value={'true'}>Yes</MenuItem>
                          <MenuItem value={'false'}>No</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='ach-method'>ACH Method</InputLabel>
                        <Select
                          labelId='ach-method'
                          value={achMethod}
                          onChange={handleAchMethod}
                          name='achMethod'
                          className='full-width-elem'>
                          <MenuItem value={'moov'}>Moov</MenuItem>
                          <MenuItem value={'default'}>Default</MenuItem>
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-moov'>
                          Moov Account
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-moov'
                          value={moov_account_id}
                          onChange={onMoonAccountChange}
                          name='group_id'
                          className='full-width-elem'>
                          {moovAccounts.map((obj) => (
                            <MenuItem key={obj && obj.id} value={obj && obj.id}>
                              {obj && obj.account_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-moov-acc'>
                          Moov Payment Methods
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-moov-acc'
                          value={moov_payment_method_id}
                          onChange={onMoovPaymentMethodChange}
                          name='group_id'
                          className='full-width-elem'>
                          {moovPaymentMethods.map((obj) => (
                            <MenuItem key={obj && obj.id} value={obj && obj.id}>
                              {obj && obj.holder_name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-smartpayables'>
                          SmartPayables Account
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-smartpayables'
                          value={smartpayables_id}
                          onChange={onSmartPayablesAccountChange}
                          name='smartpayables_id'
                          className='full-width-elem'>
                          <MenuItem value=''>
                            <em>
                              {organization_id
                                ? smartPayablesAccounts.filter(
                                    (obj) =>
                                      obj.organization_id === organization_id,
                                  ).length === 0
                                  ? 'No SmartPayables accounts available for selected organization'
                                  : 'Select SmartPayables Account'
                                : 'Select organization first'}
                            </em>
                          </MenuItem>
                          {smartPayablesAccounts
                            .filter(
                              (obj) =>
                                !organization_id ||
                                obj.organization_id === organization_id,
                            )
                            .map((obj, index) => (
                              <MenuItem value={obj && obj.id} key={index}>
                                {obj && obj.name}
                              </MenuItem>
                            ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='bank-name'>Bank Name</InputLabel>
                        <Select
                          labelId='bank-name'
                          value={bankName}
                          onChange={handleBankName}
                          name='bankName'
                          className='full-width-elem'>
                          {Object.values(bankNames).map((obj, index) => (
                            <MenuItem key={index} value={obj}>
                              {obj}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-select'>
                      <FormControl variant='standard'>
                        <InputLabel id='demo-simple-select-org'>
                          Organizations
                        </InputLabel>
                        <Select
                          labelId='demo-simple-select-org'
                          value={organization_id}
                          onChange={onOrganizationIdChange}
                          name='organization_id'
                          className='full-width-elem'
                          disabled={organizationId}>
                          {organizations.map((obj) => (
                            <MenuItem key={obj && obj.id} value={obj && obj.id}>
                              {obj && obj.name}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText='Client Facility ID'
                      id='client_facility_id'
                      name='client_facility_id'
                      onChange={handleClientFacilityId}
                      value={client_facility_id}
                      type='text'
                      formControlProps={{
                        fullWidth: true,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl component='fieldset'>
                      <FormLabel component='label'>
                        Allowed Refund Types
                      </FormLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={allowed_refund_types.includes('regular')}
                              onChange={handleAllowedRefundTypesChange}
                              name='regular'
                            />
                          }
                          label='Consumer Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={allowed_refund_types.includes(
                                'insurance',
                              )}
                              onChange={handleAllowedRefundTypesChange}
                              name='insurance'
                            />
                          }
                          label='Insurance Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={allowed_refund_types.includes(
                                'business',
                              )}
                              onChange={handleAllowedRefundTypesChange}
                              name='business'
                            />
                          }
                          label='Business Payments'
                        />
                      </FormGroup>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <FormControl component='fieldset'>
                      <FormLabel component='label'>
                        Allowed Refund Attachments
                      </FormLabel>
                      <FormGroup row>
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                !allowed_refund_types.includes('regular')
                              }
                              checked={allowedRefundAttachments.includes(
                                'regular',
                              )}
                              onChange={handleAllowRefundAttachments}
                              name='regular'
                            />
                          }
                          label='Consumer Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                !allowed_refund_types.includes('insurance')
                              }
                              checked={allowedRefundAttachments.includes(
                                'insurance',
                              )}
                              onChange={handleAllowRefundAttachments}
                              name='insurance'
                            />
                          }
                          label='Insurance Payments'
                        />
                        <FormControlLabel
                          control={
                            <Checkbox
                              disabled={
                                !allowed_refund_types.includes('business')
                              }
                              checked={allowedRefundAttachments.includes(
                                'business',
                              )}
                              onChange={handleAllowRefundAttachments}
                              name='business'
                            />
                          }
                          label='Business Payments'
                        />
                      </FormGroup>
                    </FormControl>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <CustomInput
                      labelText={t('facilities.update.pgpKeyLabel')}
                      id='outbound_pgp_public_key'
                      name='outbound_pgp_public_key'
                      onChange={handleOutboundPgpPublicKey}
                      value={outbound_pgp_public_key}
                      formControlProps={{
                        fullWidth: true,
                      }}
                      inputProps={{
                        multiline: true,
                        rows: 4,
                      }}
                    />
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}>
                    <div className='custom-upload m-b-30 m-t-27'>
                      <label htmlFor='logoimg'>
                        {t('facilities.update.uploadLogoLabel')}
                      </label>
                      <br />
                      <label htmlFor='logoimg' className='custom-upload-btn'>
                        <span>Browse</span>
                        <input
                          id='logoimg'
                          name='logoimg'
                          type='file'
                          accept='.jpg,.jpeg,.png,.webp,image/jpeg,image/png,image/webp'
                          style={{ display: 'none' }}
                          onChange={handleUploadFile}
                        />
                      </label>
                    </div>
                    {image_upload && !fileimg ? (
                      <div className='preview-image'>
                        <img src={logo_url} width='130' />
                      </div>
                    ) : (
                      ''
                    )}
                    {fileimg ? (
                      <div className='preview-image'>
                        <img src={fileimg} width='130' />
                      </div>
                    ) : (
                      ''
                    )}
                    {fileimg ? (
                      <span
                        className='material-icons'
                        style={{ cursor: 'pointer' }}
                        onClick={() => remove()}>
                        delete
                      </span>
                    ) : (
                      ''
                    )}
                  </GridItem>
                </GridContainer>

                <GridContainer>
                  <GridItem xs={12} sm={12} md={6}>
                    <Button color='primary' type='submit'>
                      {t('common.buttons.update')}
                    </Button>
                    <Button
                      color='primary'
                      onClick={cancelfrm}
                      className='btn-cancel'
                      style={{ marginLeft: '5px' }}>
                      {t('common.buttons.cancel')}
                    </Button>
                  </GridItem>
                  <GridItem xs={12} sm={12} md={6}></GridItem>
                </GridContainer>
              </CardBody>
            </Card>
          </GridItem>
        </GridContainer>
      </form>
    </div>
  );
}
